import React from 'react';
import { Container, Box } from '@hover/blueprint';
import styled from '@emotion/styled';
import { HOW_HOVER_WORKS_CASE_STUDIES_DATA } from '../../../constants';
import Desktop from './Desktop';
import Mobile from './Mobile';
import { SlickSliderContainer } from '../../ui';

const StyledSlider = styled(SlickSliderContainer)`
  .slick-dots li button:before {
    font-size: 10px;
    opacity: 1;
    color: #e9e9e9;
  }

  @media (max-width: 1154px) {
    .slick-dots {
      bottom: 130px;
    }
  }
`;

const settings = {
  dots: true,
  infinite: true,
  speed: 1500,
  autoplaySpeed: 10000,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  arrows: false,
};

const CaseStudies: React.FC = () => (
  <Box
    w="100%"
    bg={{ base: 'neutral.0', desktop: 'brandTan.100' }}
    pt={{ base: 0, desktop: 1000 }}
    pb={{ base: 0, desktop: '184px' }}
    overflow="hidden"
  >
    <Container maxW="1200px">
      <StyledSlider {...settings}>
        {HOW_HOVER_WORKS_CASE_STUDIES_DATA.map(caseStudy => (
          <>
            <Desktop caseStudy={caseStudy} key={caseStudy.id} />
            <Mobile caseStudy={caseStudy} key={caseStudy.id} />
          </>
        ))}
      </StyledSlider>
    </Container>
  </Box>
);

export default CaseStudies;
